import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import Helmet from "react-helmet";

import Header from '../components/Header';
import NotificationCenter from '../components/NotificationCenter';
import CookiePopup from '../components/CookiePopup';

import Footer from '../components/FooterDesktop';
import SliderDesktop from '../components/SliderDesktop';
import SliderMobile from '../components/SliderMobile';
import GetStartedPopup from '../components/GetStartedPopup';
import HowItWorks from '../components/HowItWorks';
import Scroll from 'react-scroll';



let Element = Scroll.Element;

var timeout;

@autobind
class HomePage extends React.Component {
  state = {
    interval: false,
    transition: false,
    imageState:"./assets/minimaa-min.JPG",
    // onLocalHost: false,
    toggle:true,
    getStarted:false,
    witch:true,
  }

  componentDidMount(){

    // if(window.location.hostname.search("localhost")) this.setState({onLocalHost:true});
    // var img2 = new Image();
    // img2.onload = e => {
    //   var src = "";
    //   if(e.path === undefined){
    //     src = e.srcElement.currentSrc;
    //     this.setState({imageState: src});
    //   } else {
    //     src = e.path[0].src
    //     this.setState({imageState: src});
    //   }
    //   setTimeout(()=> {this.setState({transition: true})},1000);
    // }
    // img2.src = "./assets/minimaa.JPG";
    
  }


  


  desktopSwitch(){
    this.setState({toggle:!this.state.toggle})
  }
  desktopOn(){
    this.setState({toggle:true})
  }
  desktopOff(){
    this.setState({toggle:false})
  }

  // changeInterval(){
  //   this.setState({interval: !this.state.interval});
  //   var img = new Image();
  //   if(this.state.interval){
  //     img.onload = (e) => {
  //       var src = "";
  //       if(e.path === undefined){
  //         src = "./assets/jakaberdnik2.jpg";
  //       } else {
  //         src = e.path[0].src
  //       }
  //       setTimeout(()=> this.setState({imageState: src}),1000);
  //     }
  //     img.src = "./assets/jakaberdnik2.jpg";
  //   } else {
  //     img.onload = (e) => {
  //       var src = "";
  //       if(e.path === undefined){
  //         src = "./assets/jakaberdnik1.jpg";
  //       } else {
  //         src = e.path[0].src
  //       }
  //       setTimeout(()=> this.setState({imageState: src}),1000);
  //     }
  //     img.src = "./assets/jakaberdnik1.jpg";
  //   }
  // }
  closeGetStarted(){
    this.setState({getStarted:false});
    clearTimeout(timeout);
    window.location = "https://minimaa.co"
  }
  getStarted(){
    this.setState({getStarted:true});
    let redirect;
    if(process.env.NODE_ENV === "development"){
      redirect = `https://api.instagram.com/oauth/authorize/?client_id=339050930369343&redirect_uri=https://start.localhost:4000/login&scope=user_profile,user_media&response_type=code`;
    } else if(process.env.NODE_ENV === "test"){
      redirect = `https://api.instagram.com/oauth/authorize/?client_id=339050930369343&redirect_uri=https://start.minimaa.io/login&scope=user_profile,user_media&response_type=code`;
    } else {
      redirect = "https://api.instagram.com/oauth/authorize/?client_id=7f3eca98290b4b829c345888daebd8c4&redirect_uri=https://start.minimaa.co/login&response_type=code";
    }
    timeout = setTimeout( function() { window.location = redirect }, 500 );
  }

  render() {
 

    return (
      <React.Fragment>
      <CookiePopup />
      <GetStartedPopup close={this.closeGetStarted} getStarted={this.state.getStarted} />
      <div className={css(styles.wrapper)}>
        <Header />
        <Helmet>
          <title>new age portfolio for artists | Minimaa</title>
          <meta name="description" content="Minimaa is an intuitive website builder made for Instagram creatives who want to boost their online presence. It only takes a minute."/>
        </Helmet>
        <div className={css(styles.wrapperBackground)}>
          <img alt="minimaa background 1" key="1" className={css(styles.backgroundImg2)} src="../assets/minimaaMobile.jpg"/>
          <img alt="minimaa background 2" key="2" className={css(styles.backgroundImg1)} src="../assets/minimaa_influencer.jpg"/>
          {/*<div className={css(styles.gradient)} />*/}
     
          <div className={css(styles.innerWrapper)}>
            <div className={css(styles.h1Warpper)}>
              <h1>new age portfolio for artists</h1>
            </div>
            {/*
            <div className={css(styles.h2Warpper)}>
              <h2></h2>
            </div>
            <div className={css(styles.h2WarpperMobile)}>
              <h2></h2>
            </div>
            */}
              <button onClick={()=>this.getStarted()} id="doitnow" className={css(styles.button)}>
                SIGN IN WITH INSTAGRAM
              </button>
            <p className={css(styles.heroFootnote)}>Free for students. PRO’s 5€ per month.</p>
          </div>
        </div>


        <NotificationCenter />

        <Element className={css(styles.section)} id="showcase" name="showcase">
          <div className={css(styles.section11)}>
            <div className={css(styles.h4Wrapper)}>
              <h4 className={css(styles.subtitle)}>EXAMPLE</h4>
            </div>
            <h3>See how your Instagram changes into a portfolio.</h3>
            <div className={css(styles.button3Wrapper)}>
              <button onClick={()=>this.getStarted()} id="doitnow" className={css(styles.button)}>
                SIGN IN WITH INSTAGRAM
              </button>
            </div>
            <div className={css(styles.desktopSwitchWrapper1)}>
              <div onClick={this.desktopOn} className={css(styles.desktopSwitchText)}>Desktop</div>
              <div onClick={this.desktopSwitch} className={css(styles.desktopSwitch)}>
                <div style={this.state.toggle ? {left:2} : {left:24,}} className={css(styles.desktopSwitchBulet)} />
              </div>
              <div onClick={this.desktopOff} className={css(styles.desktopSwitchText)}>Mobile</div>
            </div>
          </div>
          <div className={css(styles.section12Slider)}>
            {this.state.toggle ? <SliderDesktop /> : <SliderMobile /> }
          </div>
          <div className={css(styles.desktopSwitchWrapper2)}>
            <div onClick={this.desktopOn} className={css(styles.desktopSwitchText)}>Desktop</div>
            <div onClick={this.desktopSwitch} className={css(styles.desktopSwitch)}>
              <div style={this.state.toggle ? {left:3} : {left:25,}} className={css(styles.desktopSwitchBulet)} />
            </div>
            <div onClick={this.desktopOff} className={css(styles.desktopSwitchText)}>Mobile</div>
          </div>
        </Element>


        <Element className={css(styles.section)} id="how-it-works" name="how-it-works">
          <div className={css(styles.section11)}>
            <div className={css(styles.h4Wrapper)}>
              <h4 className={css(styles.subtitle)}>HOW</h4>
            </div>
            <h3>Minimaa uses your instagram content and turns it into a website.</h3>
            <div className={css(styles.button3Wrapper)}>
              <button onClick={()=>this.getStarted()} id="doitnow" className={css(styles.button)}>
                SIGN IN WITH INSTAGRAM
              </button>
            </div>
          </div>
          <div className={css(styles.section12)}>
            <HowItWorks />
          </div>
        </Element>





        <Element className={css(styles.section)} id="benefits" name="benefits">
          <div className={css(styles.section11)}>
            <div className={css(styles.h4Wrapper)}>
              <h4 className={css(styles.subtitle)}>WHY</h4>
            </div>
            <h3>Minimaa helps you grow faster.</h3>
            <div className={css(styles.button3Wrapper)}>
              <button onClick={()=>this.getStarted()} id="doitnow" className={css(styles.button)}>
                SIGN IN WITH INSTAGRAM
              </button>
            </div>
          </div>
          <div className={css(styles.section12)}>
            <div className={css(styles.howWrapper)}>
            
              <div className={css(styles.h4Wrapper)}>
                <h4>Save time</h4>
              </div>
              <p>Don’t waste time designing and building a website from scratch, focus on your content and we’ll take care of the rest.</p>
            </div>
            <div className={css(styles.howWrapper)}>
              <div className={css(styles.h4Wrapper)}>
                <h4>Mobile first</h4>
              </div>
              <p>Make changes to your website on the go using your smartphone and get stuff done whenever and wherever you need. </p>
            </div>
            <div className={css(styles.howWrapper)}>
              
              <div className={css(styles.h4Wrapper)}>
                <h4>Be seen</h4>
              </div>
              <p>3.5 billion people use search engines to find what they are looking for. Your new website is SEO friendly.  </p>
            </div>
            <div className={css(styles.howWrapper)}>
      
              <div className={css(styles.h4Wrapper)}>
                <h4>No maintenance</h4>
              </div>
              <p>Once set up, your website syncs with Instagram and stays auto-updated in the background. Fast and reliable. </p>
            </div>
          </div>
        </Element>
     


      </div>
      <Footer />
      </React.Fragment>
    );
  }
}

const styles = StyleSheet.create({
  desktopSwitchWrapper1:{
    marginTop:150,
    display:"flex",
    alignItems:"center",
    justifyContent:"flex-start",
    '@media (max-width: 1020px)': {
      display:"none",
    },
  },
  desktopSwitchWrapper2:{
    margin:"0 auto",
    marginTop:20,
    display:"flex",
    alignItems:"center",
    justifyContent:"flex-start",
    '@media (min-width: 1020px)': {
      display:"none",
    },
  },

  desktopSwitchText:{
    fontSize:12,
    userSelect: "none",
    cursor:"pointer",
    color:"#A3A3A3",
    '@media (max-width: 800px)': {
      fontSize:14,
    },
  },
  desktopSwitch:{
    marginLeft:10,
    marginRight:10,
    background:"#F3F4F7",
    borderRadius:11,
    height:22,
    cursor:"pointer",
    width:44,
    position:"relative",
    '@media (max-width: 800px)': {
      width:48,
      height:26,
      borderRadius:12,
      marginLeft:12,
      marginRight:12,
    },
  },
  desktopSwitchBulet:{
    background:"#3A80E4",
    borderRadius:9,
    width:18,
    height:18,
    transition:"0.1s ease-in-out",
    top:2,
    position:"absolute",
    '@media (max-width: 800px)': {
      width:20,
      height:20,
      borderRadius:10,
      top:3,
    },
  },
  wrapper:{
    width:"calc(100vw - 240px)",
    margin:"0 auto",
    maxWidth:1150,

    '@media (max-width: 1300px)': {
      width:"calc(100% - 130px)",
    },
    '@media (max-width: 1150px)': {
      width:"calc(100% - 60px)",
    },
    '@media (max-width: 420px)': {
      width:"calc(100% - 30px)",
    },
    '@media (max-width: 340px)': {
      width:"100%",
    },
  },
  wrapperBackground:{
    width:"100%",
    color:"#fff",
    position:"relative",

  },
  innerWrapper:{
    position:"absolute",
    top:0,
    left:100,
    display:"flex",
    flexDirection:"column",
    justifyContent: 'center',
    alignItems:"flex-start",
    bottom:0,
    margin:"0 auto",
    width:"calc(100% - 200px)",
    '@media (max-width: 1400px)': {
      width:"calc(100% - 140px)",
      left:70,
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 80px)",
      left:40,
    },
    '@media (max-width: 420px)': {
      width:"calc(100% - 50px)",
      left:25,
    },
    '@media (max-width: 340px)': {
      width:"calc(100% - 50px)",
      left:25,
    },
  },
  backgroundImg1:{
    width:"100%",
    minHeight:600,
    objectFit:"cover",
    objectPosition: "0% 45%",
    maxHeight:700,
    background:"#3a3c27",
    '@media (max-width: 800px)': {
      display:"none"
    },
  },
  backgroundImg2:{
    width:"100%",
    minHeight:600,
    objectFit:"cover",
    objectPosition: "0% 45%",
    maxHeight:700,
    background:"#3a3c27",
    '@media (min-width: 801px)': {
      display:"none"
    },
    '@media (max-width: 800px)': {
      objectPosition: "100% 0%",
      minHeight:440,
      maxHeight:460,
    },
  },

  gradient:{
    background: "linear-gradient(89.79deg, rgba(40, 39, 44, 0.9) 0.11%, rgba(40, 39, 44, 0) 50%)",
    position:"absolute",
    width:"100%",
    top:0,
    bottom:4,
    left:0,
    right:0,
    '@media (max-width: 470px)': {
      background: "linear-gradient(100.3deg, #28272C 9.49%, rgba(40, 39, 44, 0) 63.84%)",
    }
  },
  heroFootnote:{
    marginTop:20,
    fontSize:12,
    lineHeight: "18px",
    letterSpacing: "0.136364px",
  },
  button:{
    border:"none",
    letterSpacing: "0.163636px",
    position:"relative",
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    background:"#1877F2",
    color:"#fff",
    textDecoration:"none",
    padding:"10px 22px 9px 16px",
    cursor:"pointer",
    outline:"none",
    borderRadius:"25px",
    fontSize:12,
    lineHeight:"14px",
    fontWeight:500,
    transition:"0.3s",
    ":hover":{
      background:"#1877F2",
    },
    // '@media (max-width: 420px)': {
    //   fontSize:14,
    //   padding:"13px 26px 13px 26px",
    // }
  },

  buttonImg:{
    width:16,
    marginTop:-1,
    marginRight:10,
  },


  h1Warpper:{
    marginBottom:64,
    maxWidth:500,

    '@media (max-width: 800px)': {
      maxWidth:300,

    },
    '@media (max-width: 600px)': {
      marginTop:140,
      marginBottom:24,
      maxWidth:280,
    },
    '@media (max-width: 420px)': {
      marginBottom:64,
    },
  },
  h2Warpper:{
    marginBottom:50,
    maxWidth:420,
    '@media (max-width: 800px)': {
      maxWidth:350,
      marginBottom:30,
    },
    '@media (max-width: 600px)': {
      display:"none",
    },
  },
  h2WarpperMobile:{
    marginBottom:40,
    maxWidth:185,
    '@media (min-width: 561px)': {
      display:"none",
    },
  },





  section:{
    display:"flex",
    width:"calc(100% - 200px)",
    justifyContent:"space-between",
    margin:"150px auto",
    marginTop:50,
    paddingTop:100,
    '@media (max-width: 1400px)': {
      width:"calc(100% - 140px)",
    },
    '@media (max-width: 1150px)': {
      width:"calc(100% - 80px)",
    },
    '@media (max-width: 1020px)': {
      flexDirection:"column",
      alignItems:"center",
    },
    '@media (max-width: 800px)': {
      margin:"100px auto",
      marginTop:50,
      paddingTop:50,
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 80px)",
    },
    '@media (max-width: 600px)': {
      marginTop:96,
      paddingTop:0,
    },
    '@media (max-width: 420px)': {
      width:"calc(100% - 20px)",
    },
    '@media (max-width: 340px)': {
      width:"calc(100% - 40px)",
    }
  },
  section11:{
    width:280,
    minWidth:280,
    '@media (max-width: 1020px)': {
      textAlign:"center",
    },
    '@media (max-width: 420px)': {
      textAlign:"left",
      maxWidth:330,
      width:"100%"
    },
  },
  subtitle:{
    fontSize:14,
    lineHeight:"21px",
    fontWeight:500,
  },
  button3Wrapper:{
    marginTop:45,
    '@media (max-width: 600px)': {
      marginTop:36,
    },
  },
  h4Wrapper:{
    marginBottom:20,
    '@media (max-width: 600px)': {
      maxWidth:290,
      width:"100%",
      marginBottom:16,
    },
  },
  section12Slider:{
    display:"flex",
    justifyContent:"flex-end",
    flexGrow:100,
    '@media (max-width: 1020px)': {
      marginTop:60,
      width:"100%",
      justifyContent:"center",
    },
    '@media (max-width: 600px)': {
      height:404,
    },
  },
 
  section12:{
    display:"flex",
    flexWrap:"wrap",
    justifyContent:"flex-end",
    '@media (max-width: 1020px)': {
      width:560,
      justifyContent:"space-between",
    },
    '@media (max-width: 800px)': {
      justifyContent:"space-between",
    },
    '@media (max-width: 600px)': {
      flexDirection:"column",
      marginTop:20,
      maxWidth:330,
      width:"100%",
    },
    '@media (max-width: 420px)': {
    }
  },
  
 

  
  
 
  howWrapper:{
    marginBottom:80,
    marginLeft:60,
    width:240,
    '@media (max-width: 1020px)': {
      marginLeft:0,
      marginRight:0,
      width:240,
      marginTop:80,
      marginBottom:0,
    },
    '@media (max-width: 600px)': {
      maxWidth:330,
      width:"100%",
      marginTop:64,
    },
  },


  





});

export default HomePage;
